import { createSelector } from "reselect";

const totalNodeComponents = (state) =>
  state.designChapter.currentView.totalNodeComponents;

const correctNodeComponents = (state) =>
  state.designChapter.currentView.correctNodeComponents;

const showFeedback = (state) => state.designChapter.currentView.showFeedback;

export const getIsModalOpen = createSelector(
  [correctNodeComponents, totalNodeComponents, showFeedback],
  (correctNodeComponents, totalNodeComponents, showFeedback) => {
    if (showFeedback && totalNodeComponents === correctNodeComponents)
      return true;
    else return false;
  }
);
